// Models
/** Extension fields for the copilot */ export class CopilotExtensions {
    constructor(loopPageUrl, id, workflowSubmitTimeStamp){
        this.loopPageUrl = loopPageUrl;
        this.id = id;
        this.workflowSubmitTimeStamp = workflowSubmitTimeStamp;
    }
}
